import { render, staticRenderFns } from "./dataDict.vue?vue&type=template&id=8256b1ce&"
import script from "./dataDict.vue?vue&type=script&lang=js&"
export * from "./dataDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports